/* global $, bootstrap */

import * as Sentry from '@sentry/browser'

export function reload() {
    window.location.reload()
}

export function querySelector(selector) {
    return document.querySelector(selector)
}

export function getCsrfToken() {
    return querySelector('meta[name=csrf-token]').content
}

export function getCsrfParam() {
    return querySelector('meta[name=csrf-param]').content
}

export function showModal(modalForm, options, result) {
    // eslint-disable-next-line no-undef
    const Modal = window.Modal || bootstrap.Modal

    const modalObject = new Modal(modalForm[0])

    modalForm.on('show.bs.modal', () => {
        if (options.beforeShow) {
            options.beforeShow(modalObject, modalForm, options, result)
        }
    })
    modalForm.on('shown.bs.modal', () => {
        if (options.afterShow) {
            options.afterShow(modalObject, modalForm, options, result)
        }
    })
    modalForm.on('hide.bs.modal', () => {
        if (options.beforeHide) {
            options.beforeHide(modalObject, modalForm, options, result)
        }
    })
    modalForm.on('hidden.bs.modal', () => {
        modalForm.remove()
        if (options.afterHide) {
            options.afterHide(modalObject, modalForm, options, result)
        }
    })
    modalForm.on('click', '.js-submit', e => {
        e.preventDefault()
        submitForm(modalObject, options, modalForm)
        return false
    })
    modalObject.show()
}

export function submitForm(modalObject, options, modalForm) {
    const el = modalForm.find('form')[0]
    return fetch(el.action, {
        method: el.method,
        body: new URLSearchParams(new FormData(el))
    })
        .then(response => response.json())
        .then(r => processResponse(r, options))
        .catch(e => showError(e))
        .finally(() => modalObject.hide())
}

export function showError(e) {
    if (e.status === 403) {
        alert('Операция запрещена')
    } else {
        alert(e.toString())
    }
}

export function processResponse(response, options) {
    if (response.form) {
        showModal($(response.form), options, response)
    } else if (response.model) {
        if (options.afterClose) {
            options.afterClose(response, options)
        }
    } else if (response.location) {
        window.location = response.location
    } else {
        showError({
            responseText: 'Invalid response',
            status: 0
        })
    }
}

export function datepicker(root, options = {}) {
    const defaultOptions = {
        format: 'd.m.Y',
        lang: 'ru',
        dayOfWeekStart: 1,
        timepicker: false,
        scrollInput: false
    }
    const resultOptions = {...defaultOptions, ...options}
    $('.datepicker', root).datetimepicker(resultOptions)
}

export function datetimepicker(root, options = {}) {
    const defaultOptions = {
        format: 'd.m.Y H:i',
        lang: 'ru',
        dayOfWeekStart: 1,
        timepicker: true,
        scrollInput: false
    }
    const resultOptions = {...defaultOptions, ...options}
    $('.datetimepicker', root).datetimepicker(resultOptions)
}

export function selectpicker(root) {
    $('.selectpicker', root).selectpicker()
}

export function timepicker(selector) {
    $('.timepicker', selector).datetimepicker(
        {
            format: 'H:i',
            lang: 'ru',
            datepicker: false,
            scrollInput: false,
            allowTimes: [
                '01:00',
                '02:00',
                '03:00',
                '04:00',
                '05:00',
                '06:00',
                '07:00',
                '08:00',
                '09:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00'
            ]
        }
    )
}

export function _hasOwnProperty(obj, field) {
    return Object.prototype.hasOwnProperty.call(obj, field)
}

export function getElementById(id) {
    return document.getElementById(id)
}

export function initTooltip() {
    // eslint-disable-next-line no-undef
    const Tooltip = window.Tooltip || bootstrap.Tooltip
    $('[data-bs-toggle="tooltip"]').each((i, e) => new Tooltip(e))
}

export function updateSelectPickerHtml(selector, html) {
    const oldValue = selector.val()
    selector.selectpicker('destroy')
    selector.html(html)
    selector.val(oldValue)
    selector.selectpicker()
}

export function updateSelectPickerId(selector, id) {
    selector.selectpicker('destroy')
    selector.val(id)
    selector.selectpicker()
}

export function bindShowModal(selector, options) {
    selector.on('click', e => {
        e.preventDefault()
        e.currentTarget.style.visibility = 'hidden'
        const url = e.currentTarget.href
        fetchModal(url, options).finally(() => {
            e.currentTarget.style.visibility = 'visible'
        })
        return false
    })
}

export function fetchModal(url, options) {
    return fetch(url)
        .then(function(r) {
            if (!r.ok) {
                throw Error(
                    'Внутрення ошибка приложения. Мы уже занимаемся решением вопроса')
            }
            const contentType = r.headers.get('content-type')
            if (!contentType.startsWith('application/json')) {
                throw Error(
                    'Внутрення ошибка приложения. Мы уже занимаемся решением вопроса')
            }
            return r
        })
        .then(response => response.json())
        .then(response => processResponse(response, options))
        .catch(e => showError(e))
}

const DOMContentLoadedCallbacks = []

export const onDOMContentLoaded = callback => {
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!DOMContentLoadedCallbacks.length) {
            document.addEventListener('DOMContentLoaded', () => {
                for (const callback of DOMContentLoadedCallbacks) {
                    callback()
                }
            })
        }

        DOMContentLoadedCallbacks.push(callback)
    } else {
        callback()
    }
}

export function configureSentry(sentry) {
    if (sentry) {
        Sentry.init({dsn: sentry, tracesSampleRate: 0.5})
    }
}
